<div class="max-height data-monitor-container">
  <!-- 計測 -->
  <wrapped-teleport :destinationId="modalContentId" :noRenderTeleport="!modalContentId" :disabled="!showModal">
    <div v-if="!unmountMeasure" style="height: 100%;">
      <div :class="getAreaStyle()">
        <data-monitor-execute
          class="data-monitor"
          ref="data_monitor_execute"
          :inPlaying="inPlaying"
          :conversionList="conversionList"
          :dataMonitorList="dataMonitorList"
          :selectedFunctionList="selectedFuncs"
          :selectedFunctionHash="selectedFunctionHash"
          :graphConfigInfo="graphConfigInfo"
          :completeResolve="completeResolve"
          :baseOrgTime="baseTime"
          :baseTimeOffset="baseTimeOffset"
          :projectId="projectId"
          :measuredId="measuredId"
          :funcValues="funcValues"
          :specifiedSystemId="systemId"
          :dataMonitorFunctionSettings="dataMonitorFunctionSettings"
          :savedMarkerInfo="markerInfo"
          :showModal="showModal"
          :graphSettingsDestinationId="graphSettingsDestinationId"
          @toggle-playing="togglePlaying"
          @change-selected-funcs="changeSelectedFuncs"
          @show-disconnected-server-error="showCommonError"
          @back-select="backSelect"
          @set-graph-config="setGraphConfig"
          @change-check-value="changeCheckValue"
          @measure-component-mounted="measureMountedEvent"
        />
      </div>
    </div>
  </wrapped-teleport>
  <processing-view :processing="isDisplayProcessing" />
</div>
